import { _post } from "../Api";
import { toast } from "react-toastify";
import cloudStore from "./CloudStore";
import { setSpMerchant } from "./CloudActions";

export function updateArrangement(spMerchantId, spAyceArticleFlag, newData) {
  return updateArrangements(spMerchantId, [spAyceArticleFlag], [newData]).then((spAyceArticleFlags) => {
    return Promise.resolve(spAyceArticleFlags[0]);
  });
}

export function updateArrangements(spMerchantId, spAyceArticleFlags, newData) {
  let data = [];
  for (let i in spAyceArticleFlags) {
    if (spAyceArticleFlags[i]) {
      data.push({
        spAyceArticleFlagId: spAyceArticleFlags[i].id,
        ...newData[i],
      });
    } else {
      data.push({
        sp_merchant_id: spMerchantId,
        ...newData[i],
      });
    }
  }
  return _post(`/nova/v2/sp_merchants/${spMerchantId}/sp_ayce_article_flags`, data)
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      let newSpMerchant = JSON.parse(
        JSON.stringify(cloudStore.merchant.sp_merchants.find((spMerchant) => spMerchant.id === spMerchantId))
      );
      let newFlags = [...newSpMerchant.sp_ayce_setting.sp_ayce_article_flags];
      res.data.forEach((arrangement) => {
        let index = newFlags.map((arrangement) => arrangement.id).indexOf(arrangement.id);
        if (arrangement.deleted_at) {
          newFlags.splice(index, 1);
        } else {
          if (index === -1) {
            newFlags.push(arrangement);
          } else {
            newFlags.splice(index, 1, arrangement);
          }
        }
      });
      newSpMerchant.sp_ayce_setting.sp_ayce_article_flags = newFlags;
      setSpMerchant(newSpMerchant);
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data);
    });
}
